/* eslint-disable no-underscore-dangle */
import { Component, AfterViewInit, EventEmitter, Input, Output,
    ViewChildren, ViewContainerRef, QueryList, ChangeDetectorRef } from '@angular/core';

import { HisAuthService, HisBaseGlobalsService, HisDynamicFieldConfig, HisValueGroup, HisNotificationService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { DataDictionaryUtils } from 'app/fs/res/common/utils/data-dictionary-utils';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { PublicationType } from 'app/fs/res/publication/model/publication-type';
import { Publication } from 'app/fs/res/publication/model/publication';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicContentUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-content-utils';

@Component( {
    selector: 'res-publication-edit-additional-data',
    templateUrl: './publication-edit-additional-data.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationEditAdditionalDataComponent)],
} )
export class PublicationEditAdditionalDataComponent implements AfterViewInit {
    @Input('publication') set pub(publication: Publication) {
        this.publication = publication;
        if (publication?.changeRequest) {
            this.keyWordsFieldConfig =
                this.dynamicContentUtils.createDynamicFormFieldConfig(this.publication.changeRequest._dynamicComponent, 'keywords');
        } else {
            this.keyWordsFieldConfig = null;
        }

        if (publication) {
            const calculatedNumberOfPages = this.calculateNumberOfPages(false);
            this.numberOfPagesManuallySet = this.publication.numberOfPages && (calculatedNumberOfPages !== this.publication.numberOfPages);
        }
    }
    publication: Publication;
    @Input() childPublication: Publication;
    @Input() publicationTypeChildParentMap: {[key: string]: PublicationType[]};
    @Input() changeRequestValueGroup = new HisValueGroup( 1 );
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;
    @Output() navigationLastUrlChange = new EventEmitter<string>();
    @Output() navigateToCreateParentOnNextSave = new EventEmitter<boolean>();
    @Output() navigateToEditParentOnNextSave = new EventEmitter<boolean>();

    keyWordsFieldConfig: HisDynamicFieldConfig;
    changeRequesForm: UntypedFormGroup = new UntypedFormGroup( {} );
    numberOfPagesManuallySet = false;
    hiskeyIdsForPublicationTypeBook = [1,2,16,20];

    constructor(
        private changeDetectorRef: ChangeDetectorRef, // to prevent ExpressionChangedAfterItHasBeenCheckedError
        public auth: HisAuthService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        public dynamicContentUtils: DynamicContentUtils,
        private notificationService: HisNotificationService,
        private ddUtils: DataDictionaryUtils ) {
    }

    ngAfterViewInit() {
        // trigger re-render count of ViewChildren dynamicFieldContainer
        this.fieldViewContainerList.changes.subscribe( (changes: any) => {
            // eslint-disable-next-line no-underscore-dangle
            if ( this.publication._dynamicComponent && this.hisBaseGlobalsService.isAnyModuleActive( 'HISINONERES' ) ) {
                // eslint-disable-next-line no-underscore-dangle
                this.publication._dynamicComponent = { ...this.publication._dynamicComponent };
            }
            console.log( 'fieldViewContainerList.toArray().length: ', this.fieldViewContainerList.toArray().length );
            this.changeDetectorRef.detectChanges();
        } );
    }

    public get isPublicationTypeBook() {
        return this.hiskeyIdsForPublicationTypeBook.some(hiskeyId => hiskeyId === this.publication.publicationType?.hiskeyId);
    }

    public getDdKey( source: string ): string {
        return DataDictionaryUtils.dDKeyPublicationType( this.publication.publicationType, source );
    }

    public getIsDynamicContainerVisible( source: string ): boolean {
        return this.ddUtils.isVisible( this.getDdKey( source ) );
    }

    public getLabeltextIdentifier( source: string ) {
        return this.hisBaseGlobalsService.getDd( this.getDdKey(source) )?.labeltextIdentifier;
    }

    public isRequired( source: string ) {
        return this.hisBaseGlobalsService.getDd( this.getDdKey(source) )?.required;
    }

 	public isHidden( source: string ) {
        return this.hisBaseGlobalsService.getDd( this.getDdKey(source) )?.hidden;
    }

    /* clear <p-autoComplete> field */
    public onClear( field: string ) {
        switch ( field ) {
            case 'publicationResource': this.publication.publicationResource = null; break;
            case 'publicationResourceType': this.publication.publicationResourceType = null; break;
            case 'peerReviewedProcess': this.publication.peerReviewedProcess = null; break;
            case 'access': this.publication.access = null; break;
            case 'qualificationThesis': this.publication.qualificationThesis = null; break;
            default: console.log( 'ERROR: Unsupported field:', field );
        }
    }

    public calculateNumberOfPages(setNumberOfPages: boolean) {
        const pageRangeFrom = parseFloat(this.publication.pageRangeFrom);
        const pageRangeTo = parseFloat(this.publication.pageRangeTo);
        if (pageRangeFrom % 1 === 0 && pageRangeTo % 1 === 0
            && !isNaN(pageRangeFrom) && !isNaN(pageRangeTo) && pageRangeTo >= pageRangeFrom) {
            const result = pageRangeTo - pageRangeFrom + 1;
            const isValidvalue = result > 0 && result <= 999999999;
            if (setNumberOfPages && !this.numberOfPagesManuallySet && isValidvalue) {
                this.publication.numberOfPages = result;
            }
            return isValidvalue ? result : null;
        }
        return null;
    }

    public checkNumberOfPages() {
        const calculatedNumberOfPages = this.calculateNumberOfPages(false);
        if ( this.publication.numberOfPages && calculatedNumberOfPages && calculatedNumberOfPages !== this.publication.numberOfPages) {
            this.numberOfPagesManuallySet = true;
            this.notificationService.clear();
            this.notificationService.infoI18n(
                'fs.res.publication.Publication.numberOfPages.inputHint',
                calculatedNumberOfPages,
                this.publication.numberOfPages
            );
        } else if (calculatedNumberOfPages && calculatedNumberOfPages === this.publication.numberOfPages) {
            this.numberOfPagesManuallySet = false;
        }
    }

    /* callback to set last window location href */
    public onNavigationLastUrlChange( lastWindowLocation: string ) {
        this.navigationLastUrlChange.emit( lastWindowLocation );
    }

}
